import { PREDEFINED_RANGES_MAP } from '../predefined-ranges'

export const MAP_LAYERS_MAPPING = {
	FIELDS: 'fields',
	CROPS: 'crops',
	INFRASTRUCTURES: 'infrastructures',
	TRACKS: 'tracks',
	PLAN_FACT: 'planFact',
	SATELLITES: 'satellites',
	LOGISTICS: 'logistics',
	LANDS: 'lands',
}

export const LAYER_ICONS = {
	[MAP_LAYERS_MAPPING.FIELDS]: 'mapField',
	[MAP_LAYERS_MAPPING.CROPS]: 'mapLeaf',
	[MAP_LAYERS_MAPPING.INFRASTRUCTURES]: 'mapInfrastructureObject',
	[MAP_LAYERS_MAPPING.TRACKS]: 'monitoring',
	[MAP_LAYERS_MAPPING.PLAN_FACT]: 'fieldOrders',
	[MAP_LAYERS_MAPPING.SATELLITES]: 'satellite',
	[MAP_LAYERS_MAPPING.LOGISTICS]: 'mapPathOrder',
	[MAP_LAYERS_MAPPING.LANDS]: 'mapDrawing',
}

export const LAYERS_WITHOUT_GLOBAL_FILTERS = [
	MAP_LAYERS_MAPPING.FIELDS,
	MAP_LAYERS_MAPPING.INFRASTRUCTURES,
	MAP_LAYERS_MAPPING.LANDS,
]

export const LAYERS_WHERE_DISABLED_CHANGING_LEGEND_TYPE = [
	MAP_LAYERS_MAPPING.SATELLITES,
]

export const MAP_LAYERS_WHERE_DISABLED_AGGREGATION_IN_LEGENDS = [
	MAP_LAYERS_MAPPING.SATELLITES,
]

export const MAP_LAYER_ENTITY_TYPES_MAPPING = {
	FIELD: 'field',
	CROP: 'crop',
	CROP_ICON: 'cropIcon',
	INFRASTRUCTURE: 'infrastructure',
	TRACK: 'track',
	MACHINE: 'machine',
	EVENT: 'event',
	PLAN: 'plan',
	FACT: 'fact',
}

export const DECK_LAYER_TYPES_OF_MAP_TRACKS_LAYER = {
	MACHINES: 'tracksAnimatedDeckLayer',
	MACHINES_LABELS: 'tracksAnimatedLabelDeckLayer',
	MACHINES_LIVE: 'tracksAnimatedLiveDeckLayer',
	MACHINES_LIVE_LABELS: 'tracksAnimatedLiveLabelDeckLayer',
	TRACKS: 'tracksPathsDeckLayer',
	TRACKS_PERMISSIBLE_SPEED: 'tracksPermissibleSpeedPathsDeckLayer',
	TRACKS_LIVE: 'tracksLivePathsDeckLayer',
	EVENTS: 'trackEventsIconsDeckLayer',
}
// DECK_LAYER_TYPES_OF_MAP_TRACKS_LAYER.EVENTS

export const mapLayerEntityListComponentDefaultProps = {

	layerKey: {
		type: String,
		default: null,
	},

	layerType: {
		type: String,
		default: null,
	},

}

export const MAP_LAYER_MAPPING_FOR_COMPRESSION = [
	{key: 'key', index: 0},
	{key: 'globFilterSelected', index: 1},
	{key: 'activeAnalyticEntityId', index: 2},
	{key: 'analyticPanelHeight', index: 3},
	{key: 'activePreview', index: 4},
	{key: 'selectedLegendAttribute', index: 5},
	{key: 'selectedLegendType', index: 6},
	{key: 'activeLegendPresetId', index: 7},
	{key: 'activePresetId', index: 8},
	{key: 'visible', index: 9},
	{key: 'isShowTitles', index: 10},
	{key: 'layerOpacity', index: 11},
	{key: 'isShowIcon', index: 12},
	{key: 'layerSpecialParams', index: 13},
]

export const MAP_INSTANCE_MAPPING_FOR_COMPRESSION = [
	{key: 'mapInstanceKey', index: 0},
	{key: 'layers', index: 1},
	{key: 'activeLayerKey', index: 2},
]

export const MAP_LAYERS_DEFAULT_CONFIGURATION = {
	[MAP_LAYERS_MAPPING.FIELDS]: {
		key: 'fields__default',
		type: 'fields',
		visible: true,
		layerOpacity: 0.7,
		globFilterSelected: {},
		activePresetId: null,
		selectedLegendAttribute: 'fields_default_legend',
		selectedLegendType: 'fieldsDefaultLegendType',
		activeLegendPresetId: null,
		isShowTitles: true,
		isShowIcons: true,
	},
	[MAP_LAYERS_MAPPING.CROPS]: {
		key: 'crops__default',
		type: 'crops',
		visible: true,
		layerOpacity: 0.7,
		globFilterSelected: {
			year: new Date().getFullYear(),
		},
		activePresetId: null,
		selectedLegendAttribute: 'culture',
		selectedLegendType: 'cultureLegendType',
		activeLegendPresetId: null,
		isShowTitles: true,
		isShowIcons: true,
	},
	[MAP_LAYERS_MAPPING.INFRASTRUCTURES]: {
		key: 'infrastructures__default',
		type: 'infrastructures',
		visible: true,
		layerOpacity: 0.7,
		globFilterSelected: {},
		activePresetId: null,
		selectedLegendAttribute: 'object_type',
		selectedLegendType: 'infrastructureObjectTypeLegendType',
		activeLegendPresetId: null,
		isShowIcons: true,
	},
	[MAP_LAYERS_MAPPING.TRACKS]: {
		key: 'tracks__default',
		type: 'tracks',
		visible: true,
		layerOpacity: 1,
		globFilterSelected: {
			__ao__dateRange: PREDEFINED_RANGES_MAP.TODAY,
		},
		activePresetId: null,
		selectedLegendAttribute: 'title',
		selectedLegendType: 'machineTitleLegendType',
		activeLegendPresetId: null,
		isShowIcons: true,
	},
	[MAP_LAYERS_MAPPING.PLAN_FACT]: {
		key: 'planFact__default',
		type: 'planFact',
		visible: true,
		layerOpacity: 0.7,
		globFilterSelected: {
			__ao__dateRange: PREDEFINED_RANGES_MAP.THIS_WEEK,
		},
		activePresetId: null,
		selectedLegendAttribute: 'work_order_code',
		selectedLegendType: 'workOrderCodeLegendType',
		activeLegendPresetId: null,
		isShowIcons: true,
	},
	[MAP_LAYERS_MAPPING.LOGISTICS]: {
		key: 'logistics__default',
		type: 'logistics',
		visible: true,
		layerOpacity: 0.7,
		globFilterSelected: {
			__ao__dateRange: PREDEFINED_RANGES_MAP.TODAY,
		},
		activePresetId: null,
		selectedLegendAttribute: 'work_order__code',
		selectedLegendType: 'workOrderCodeLegendType',
		activeLegendPresetId: null,
		isShowIcons: true,
	},
	[MAP_LAYERS_MAPPING.SATELLITES]: {
		key: 'satellites__default',
		type: 'satellites',
		visible: true,
		layerOpacity: 0.7,
		globFilterSelected: {},
		activePresetId: null,
		selectedLegendAttribute: 'legend_ndvi',
		selectedLegendType: 'satelliteNdviLegendType',
		activeLegendPresetId: null,
		isShowIcons: true,
	},
	[MAP_LAYERS_MAPPING.LANDS]: {
		key: 'lands__default',
		type: 'lands',
		visible: true,
		layerOpacity: 0.5,
		globFilterSelected: {},
		activePresetId: null,
		selectedLegendAttribute: 'lease_expiration_year_of_land',
		selectedLegendType: 'expirationYearLegendType',
		activeLegendPresetId: null,
		isShowIcons: true,
	},
}
